import {Izbor} from "../../../komponente/izbor/Izbor";
import podaci from './podaci.json';

export default class Opkoljen extends Izbor {
  constructor() {
    super(podaci);
  }
}



// WEBPACK FOOTER //
// ./src/hronologija/1944/01-15/Opkoljen.js